<template>
  <div class="columns-cards-component container" :style="defineCssVariables">
    <ul>
      <li
        v-for="(
          { title, description, image, link, isExternalLink, anchorIdTarget }, index
        ) in items"
        :key="index"
        @click="
          $scrollTo(anchorIdTarget, 500, {
            offset: -50
          })
        "
      >
        <Link :to="anchorIdTarget ? '#' : link" :target="isExternalLink ? '_blank' : '_self'">
          <Card :title="title" :description="description" :image="image" />
        </Link>
      </li>
    </ul>
  </div>
</template>

<script>
import Card from '@/components/Prismic/Landings/Slices/ColumnsCards/Card.vue';
import Link from '@/components/Common/Link.vue';

export default {
  components: { Card, Link },
  props: {
    slice: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      columns: 2,
      primaryColor: '',
      textColor: ''
    };
  },
  computed: {
    defineCssVariables() {
      return `
      --primary-color: ${this.primaryColor};
      --texts-color: ${this.textColor};
      --columns: ${this.columns};
      --description-max-lines: ${this.columns == 2 ? 3 : 2};
      `;
    },
    isSubscriptor() {
      return this.$auth.loggedIn && this.$auth.user.idPlan != 1;
    },
    items() {
      if (!this?.slice?.items) return [];
      return this.slice.items.map((item) => {
        const link = this.linkResolver({
          isSubscriptor: this.isSubscriptor,
          linkSubscriptor: item.link_for_subscribers,
          linkFree: item.link
        });
        return {
          image: {
            src: item.image.url,
            alt: item.image.alt
          },
          title: item.title1,
          description: item.description,
          link: link,
          isExternalLink: item.external_link,
          anchorIdTarget: item.anchor_id_target
        };
      });
    }
  },
  created() {
    this.columns = this.slice.primary.columns_ammount;
    this.primaryColor = this.slice.primary.background_color;
    this.textColor = this.slice.primary.text_color;
  },
  methods: {
    linkResolver({ isSubscriptor, linkSubscriptor, linkFree }) {
      if (!linkSubscriptor && linkFree) return linkFree;
      if (linkSubscriptor && !linkFree) return linkSubscriptor;
      if (!linkSubscriptor && !linkFree) return '#';
      return isSubscriptor ? linkSubscriptor : linkFree;
    }
  }
};
</script>

<style lang="scss" scoped>
.columns-cards-component {
  ul {
    list-style: none;
    padding: 0;
    display: grid;
    flex-wrap: wrap;
    gap: 1rem;
    justify-content: center;
    @include xl {
      grid-template-columns: repeat(2, 1fr);
    }
    @include md {
      grid-template-columns: 1fr;
    }
    @include min-xl {
      grid-template-columns: repeat(var(--columns, 2), 1fr);
    }
  }
  li {
    display: grid;
  }
}
</style>
